export const Utils = {
	formatAsCurrency: (amount) => {
		return "$" + amount.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,');
	}
};
